import type { ComponentProps, ReactNode } from 'react';

import { cn } from './cn';

type ContactCardContainerProps = ComponentProps<'div'> & {
  active?: boolean;
  isChecked?: boolean;
  size?: 'default' | 'pipeline';
};

export function ContactCardContainer({
  active,
  isChecked,
  className,
  size = 'default',
  children,
  ...props
}: ContactCardContainerProps & { children?: ReactNode }) {
  return (
    <div
      className={cn(
        // Named so card-only reveals (group-hover/card) ignore the board row's bare `group`.
        'group group/card',
        'border-slate-300 bg-white ring-slate-100 hover:bg-slate-100 dark:border-slate-900 dark:bg-slate-800 dark:ring-slate-700 dark:hover:bg-slate-700',
        'relative flex w-full max-w-3xl items-stretch gap-2 overflow-hidden rounded-lg border p-2 transition-all hover:ring-4',
        size === 'pipeline' && 'gap-1 p-1',
        { 'cursor-pointer': props.onClick },
        {
          'bg-haiti-50 ring-haiti-50 hover:bg-haiti-100 dark:bg-slate-800 dark:ring-slate-800 dark:hover:bg-haiti-900':
            isChecked,
        },
        {
          'bg-haiti-100 ring-haiti-50 hover:bg-haiti-200 dark:bg-slate-900 dark:ring-slate-800 dark:hover:bg-haiti-950':
            active,
        },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}